/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 23.05.2016.
 */

import {
  FETCH_PROGRAM_GUIDE,
  APPEND_PROGRAM_GUIDE,
  GET_PROGRAM_GUIDE_FOR_CHANNEL,
  CLEAR_OLD_SCHEDULE
} from '../../actions/schedule/actions-schedule';

import {
  EMIT_COLLECTION_RECORDS_UPDATE, EMIT_COLLECTION_NOTIFICATION_UPDATE
} from '../../actions/emit/actions-emit';

import {PendingState, SuccessState, ErrorState} from '../../utils';

import _get from 'lodash/get';
import _at from 'lodash/at';
import _omit from 'lodash/omit';
import _concat from 'lodash/concat';
import _map from 'lodash/map';
import _forOwn from 'lodash/forOwn';
import _find from 'lodash/find';
import _reduce from 'lodash/reduce';

import moment from 'moment';

const INIT_STATE = {
  event: {},
  eventForProfile: {},
  schedule: {},
  scheduleForProfile: {},
  program_guide: {
    channels: [],
    schedule: [],
    fetchInProgress: false,
    appendInProgress: false
  }
};

const mergeRecords = (events) => {
  return _reduce(events, (result, event, id) => {
    result[id] = {
      ...event,
      record: _find(lh.common.records, {epg_schedule_item_id: event.id}) || null,
    };

    return result;
  }, {});
};

const mergeNotifications = (events) => {
  return _reduce(events, (result, event, id) => {
    result[id] = {
      ...event,
      notification: _find(lh.common.notifications, (notification) => {

        return _get(notification, 'program.id') === _get(event, 'program.id') && _get(notification, 'start') === _get(event, 'start');
      }) || null,
    };

    return result;
  }, {});
};

export default function (state = INIT_STATE, action) {

  switch (action.type) {

    case PendingState(FETCH_PROGRAM_GUIDE):
      return {
        ...state,
        program_guide: {
          ...state.program_guide,
          schedule: [],
          channels: [],
          fetchInProgress: true
        }
      };

    case SuccessState(FETCH_PROGRAM_GUIDE):

      return {
        ...state,
        event: {
          ...state.event,
          ..._get(action.payload, 'entities.event', {})
        },
        schedule: {
          ...state.schedule,
          ..._get(action.payload, 'entities.schedule', {})
        },
        program_guide: {
          ...state.program_guide,
          schedule: _get(action.payload, 'result', []),
          channels: _get(action.meta, 'channels', []),
          fetchInProgress: false
        }
      };

    case ErrorState(FETCH_PROGRAM_GUIDE):

      return {
        ...state,
        program_guide: {
          ...state.program_guide,
          fetchInProgress: false
        }
      };

    case PendingState(APPEND_PROGRAM_GUIDE):
      return {
        ...state,
        program_guide: {
          ...state.program_guide,
          appendInProgress: true
        }
      };

    case SuccessState(APPEND_PROGRAM_GUIDE):

      return {
        ...state,
        event: {
          ...state.event,
          ..._get(action.payload, 'entities.event', {})
        },
        schedule: {
          ...state.schedule,
          ..._get(action.payload, 'entities.schedule', {})
        },
        program_guide: {
          ...state.program_guide,
          channels: [...state.program_guide.channels, ..._get(action.meta, 'channels', [])],
          schedule: [...state.program_guide.schedule, ..._get(action.payload, 'result', [])],
          appendInProgress: false
        }
      };

    case ErrorState(APPEND_PROGRAM_GUIDE):

      return {
        ...state,
        program_guide: {
          ...state.program_guide,
          appendInProgress: false
        }
      };

    case PendingState(GET_PROGRAM_GUIDE_FOR_CHANNEL):

      if (action.meta.location === 'profile') {

        return {
          ...state,
          scheduleForProfile: {
            ...state.scheduleForProfile,
            [action.meta.key]: {
              ...state[action.meta.key],
              schedule: [],
              _fetchInProgress: true
            }
          }
        };
      } else {

        return {
          ...state,
          schedule: {
            ...state.schedule,
            [action.meta.key]: {
              ...state[action.meta.key],
              schedule: [],
              _fetchInProgress: true
            }
          }
        };
      }


    case SuccessState(GET_PROGRAM_GUIDE_FOR_CHANNEL):

      if (action.meta.location === 'profile') {
        return {
          ...state,
          eventForProfile: {
            ...state.event,
            ..._get(action.payload, 'entities.event', {})
          },
          scheduleForProfile: {
            ...state.schedule,
            [action.meta.key]: {
              ...state[action.meta.key],
              schedule: _get(action.payload, 'entities.schedule.' + action.meta.key + '.schedule', []),
              _timestamp: moment.utc().unix(),
              _fetchInProgress: false
            }
          }
        };

      } else {

        return {
          ...state,
          event: {
            ...state.event,
            ..._get(action.payload, 'entities.event', {})
          },
          schedule: {
            ...state.schedule,
            [action.meta.key]: {
              ...state[action.meta.key],
              schedule: _get(action.payload, 'entities.schedule.' + action.meta.key + '.schedule', []),
              _timestamp: moment.utc().unix(),
              _fetchInProgress: false
            }
          }
        };
      }

    case ErrorState(GET_PROGRAM_GUIDE_FOR_CHANNEL):
      if (action.meta.location === 'profile') {

        return {
          ...state,
          scheduleForProfile:{
            ...state.schedule,
            [action.meta.key]: {
              ...state[action.meta.key],
              _fetchInProgress: false
            }
          }
        };
      } else {

        return {
          ...state,
          schedule:{
            ...state.schedule,
            [action.meta.key]: {
              ...state[action.meta.key],
              _fetchInProgress: false
            }
          }
        };
      }

    case CLEAR_OLD_SCHEDULE:

      if (action.meta.location === 'profile') {
        let toClearEvent = _concat([], ..._map(_at(state.scheduleForProfile, _get(action, 'payload', [])), 'schedule'));

        return {
          ...state,
          eventForProfile: _omit(state.event, toClearEvent),
          scheduleForProfile: _omit(state.schedule, _get(action, 'payload', []))
        };
      } else {
        let toClearEvent = _concat([], ..._map(_at(state.schedule, _get(action, 'payload', [])), 'schedule'));

        return {
          ...state,
          event: _omit(state.event, toClearEvent),
          schedule: _omit(state.schedule, _get(action, 'payload', []))
        };
      }

    case EMIT_COLLECTION_RECORDS_UPDATE: {

      return {
        ...state,
        event: mergeRecords(state.event),
        eventForProfile: mergeRecords(state.eventForProfile)
      }
    }

    case EMIT_COLLECTION_NOTIFICATION_UPDATE: {

      return {
        ...state,
        event: mergeNotifications(state.event),
        eventForProfile: mergeNotifications(state.eventForProfile)
      }
    }

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/schedule/reduces-schedule.js